<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">
                        {{ this.parentObject.pageTitle }}
                        <span class="page_title_value">{{ this.parentObject.pageTitleValue }}</span>
                    </h2>
                </v-row>
                <v-row class="mb-4">
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-btn color="warning" v-on:click="goBack">{{ $t('button.back') }}</v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentdesc')" type="text"
                            ref="pmassessmentrecorddesc" v-model="formData.pmassessmentrecorddesc" 
                            dense readonly class="v-input" background-color="#ffeab2"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentcode')"  type="text"
                            v-model="formData.pmassessmentrecordcode" class="v-input"
                            dense readonly background-color="#ffeab2"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentstartdate')" type="date" ref="startdate"
                            v-model="formData.startdate" 
                            dense readonly class="v-input" background-color="#ffeab2"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentenddate')"  type="date" ref="enddate"
                            v-model="formData.enddate" 
                            dense readonly class="v-input" background-color="#ffeab2"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                        <v-autocomplete outlined :label="$t('pmassementrecord.pmassessmentratingoption')" type="text" ref="ratingid"
                            v-model="formData.ratingid" :items="ratingOptionList"
                            dense readonly class="v-input" background-color="#ffeab2"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentratingcode')" type="text" v-model="formData.ratingcode" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <v-tabs v-model="activeTab">
                    <v-tab value="details">{{$t('columns.detail')}}</v-tab>
                    <v-tab value="summary">{{$t('previewpayroll.summary')}}</v-tab>
                </v-tabs>
                <v-tabs-items v-model="activeTab">
                    <v-tab-item key="details">
                        <app-table 
                            v-bind:parentObject="{
                                tabHeader: tabHeader,
                                detailItem: parentObject.pmAssessmentRecordDetailList,
                                pmassessmentrecordid: parentObject.data.id,
                                startdate: parentObject.data.startdate,
                                enddate: parentObject.data.enddate,
                                ratingid: parentObject.data.ratingid,
                                pageTitle: this.parentObject.pageTitle +' '+this.parentObject.pageTitleValue+ ' Details',
                                isEdit: parentObject.isEdit,
                                isAdvanceEdit: parentObject.isAdvanceEdit,
                            }"
                            @updateSummary="handleUpdateSummary"
                        />
                    </v-tab-item>
                    
                    <v-tab-item key="summary">
                        <app-table2
                            :key="summaryKey"
                            v-bind:parentObject="{
                                tabHeader: tabHeader2,
                                detailItem: finalRankSummary,
                                pmassessmentrecordid: parentObject.data.id,
                                pageTitle: this.parentObject.pageTitle +' '+this.parentObject.pageTitleValue+' Summary',
                                isEdit: parentObject.isEdit,
                                isAdvanceEdit: parentObject.isAdvanceEdit,
                            }"
                        />
                    </v-tab-item>
                </v-tabs-items>
            </v-form>
        </v-container>
    </div>
</template>

<script>
//this is use after click calculation button in AdvanceEdit mode
import CRUDTable from "./CRUDTableDetail";
import CRUDTable2 from "./CRUDTableDetail2";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-table": CRUDTable,
        "app-table2": CRUDTable2,
    },

    data() {
        return {
            rules: {
                // required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                pmassessmentrecordcode: this.parentObject.data.pmassessmentrecordcode,
                pmassessmentrecorddesc: this.parentObject.data.pmassessmentrecorddesc,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                //pmassecalmethodid: this.parentObject.data.pmassecalmethodid,
                ratingid: this.parentObject.data.ratingid,
                ratingcode: this.parentObject.data.ratingcode,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid,
            },

            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '150px', sortable: false },
                { text: this.$t('columns.staffid'), value: 'staffcode', width: 'auto', sortable: false },
                { text: this.$t('columns.staffname'), value: 'staffname', width: 'auto', sortable: false },
                { text: this.$t('pmassementrecord.finalscore'), value: 'finalscore', width: 'auto', sortable: false },
                { text: this.$t('Setuprankmapset.rank'), value: 'rank', width: 'auto', sortable: false },
                { text: this.$t('pmassementrecord.finalrank'), value: 'finalrank', width: 'auto', sortable: false },
                { text: this.$t('columns.company'), value: 'companyname', width: 'auto', sortable: false },
                { text: this.$t('columns.branch'), value: 'branchcode', width: 'auto', sortable: false },
                { text: this.$t('columns.department'), value: 'departmentcode', width: 'auto', sortable: false },
                { text: this.$t('columns.division'), value: 'divisioncode', width: 'auto', sortable: false },
                { text: this.$t('columns.section'), value: 'sectioncode', width: 'auto', sortable: false },
                { text: this.$t('columns.unit'), value: 'unitcode', width: 'auto', sortable: false },
                { text: this.$t('columns.grade'), value: 'gradecode', width: 'auto', sortable: false }
            ],
            tabHeader2: [
                { text: this.$t('Setuprankmapset.rank'), value: 'rank', width: 'auto', sortable: false },
                { text: this.$t('pmassementrecord.totalcount'), value: 'totalcount', width: 'auto', sortable: false },
                { text: this.$t('pmassementrecord.distribution'), value: 'distribution', width: 'auto', sortable: false }
            ],
            finalRankSummary: [], // Store fetched summary data
            summaryKey: 0, // 🔄 Used to force reactivity after the final rank update
            
            activeTab: "details",
            errMsg: '',
            isErr: false,
            isEdit: this.parentObject.isEdit,
            isAdvanceEdit: this.parentObject.isAdvanceEdit,
            ratingOptionList: [], // take necessary data only from Full
            ratingOptionFull: [],// get full data from database
            // calMethodList: [],
            // calMethodFull: [],
        }
    },

    methods: {

        goBack() {
            if (window.history.length > 1) {
                this.$router.go(-1); // Only go back if there's a history
            } else {
                this.$router.push({ name: "performanceassessmentrecordlist" }); // Go to home if no history
            }
        },
        async loadRankMappingListHandler() {
            const vm = this;
            this.$store.dispatch('get', { url: '/rankmapset/active/all' })//get isdisable=0 ranking set
                .then((res) => {
                    vm.ratingOptionFull = res.data.rec;
                    vm.ratingOptionList = []; // Clear the list before pushing new items

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.ratingOptionList.push({
                            text: res.data.rec[i].description,
                            value: res.data.rec[i].id,
                        });
                    }

                    if (vm.formData.ratingid) {
                        // Manually trigger the change handler to update ratingcode
                        vm.changeRatingOption(vm.formData.ratingid);
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        changeRatingOption(id) {
            let item = this.ratingOptionFull.find((item) => item.id === id);
            this.formData.ratingcode = item.rankmapset;
            //this is use to get rank mapping set list
            //will add on another condition to get grid
        },

        async loadFinalRankSummary() {
            try {
                const res = await this.$store.dispatch("get", {
                    url: `/finalRankSummary/${this.parentObject.data.id}/${this.parentObject.data.ratingid}`,
                });
                if (res.data && res.data.summary) {
                    this.finalRankSummary = [...res.data.summary]; // Ensure Vue reactivity
                } else {
                    this.finalRankSummary = []; // Only reset if no valid data is returned
                    console.warn("⚠️ No summary data received.");
                }

                //  Trigger reactivity update for app-table2
                this.summaryKey++;

            } catch (err) {
                console.error("❌ Error fetching final rank summary:", err);
                this.finalRankSummary = [];
            }
        },


        async handleUpdateSummary() {
            await this.loadFinalRankSummary();
        },
    },
    
    async mounted() {
        try {
            await this.loadRankMappingListHandler();
            await this.loadFinalRankSummary();
        } catch (error) {
            console.error("❌ Error loading data:", error);
        }
    }
}
</script>

